import React, { Component } from 'react';
import _ from "i18n";
import { SubMenuLink } from "../../SubMenuLink";
export default class CampaignsEmail extends Component {
  render() {
    return <SubMenuLink pathname="/campaigns" title="campaign list" icon="EMAIL_LIGHT" />
  }
};
